import { default as themeData } from '@digital-hig/theme-data/lib/build/json/lightTheme/theme.json';

export const DHIGTheme = themeData.resolvedRoles;
